import { Link } from "@tanstack/react-router";
import { DocsSidebar } from "../DocsSidebar";
import { ArrowUpRight, UsersRound, Clipboard, Building2 } from "lucide-react";
import { groupedArticles } from "../docsContent";

/**
 * /docs landing — a short welcome plus every article grouped by audience, so a
 * signed-in user can browse without already knowing what they're looking for.
 */
export function DocsIndexPage() {
  const groups = groupedArticles();
  return (
    <div data-testid="docs-index">
      <header className="docs-index-header">
        <p className="eyebrow">
          Help center
        </p>
        <h2>
          A little help for the next step.
        </h2>
        <p>
          Guides for watching matches, reviewing feedback and running your club.
        </p>
      </header>

      <DocsSidebar searchOnly />
      <div className="docs-audience-grid">
        {groups.map(({ audience, articles }, index) => (
          <section key={audience.id} data-docs-group={audience.id}>
            <span className="docs-audience-icon">
              {index === 0 ? (
                <UsersRound />
              ) : index === 1 ? (
                <Clipboard />
              ) : (
                <Building2 />
              )}
            </span>
            <h3>
              {audience.label}
            </h3>
            <ul>
              {articles.map((a) => (
                <li key={a.slug}>
                  <Link
                    to="/docs/$slug"
                    params={{ slug: a.slug }}
                    data-testid={`docs-index-${a.slug}`}
                    className="group"
                  >
                    <span>{a.title}</span>
                    <ArrowUpRight aria-hidden="true" />
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
